import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

import type { TCoordinates } from '@/shared/lib'

export type SelectedMarker = {
  id: string
  type: 'landmark' | 'subway'
  position: TCoordinates
  nextZoomLevel?: number | null
}

type SelectedMarkerAction = {
  selectMarker: (marker: SelectedMarker) => void
  resetMarker: () => void
}

type SelectedMarkerState = {
  selectedMarker: SelectedMarker | null
  isSelected: (id: string) => boolean
  actions: SelectedMarkerAction
}

export const useSelectedMarkerStore = create<SelectedMarkerState>()(
  subscribeWithSelector((set, get) => ({
    selectedMarker: null,
    isSelected: (id: string) => {
      const { selectedMarker } = get()

      return selectedMarker?.id === id
    },
    actions: {
      selectMarker: marker => {
        set({ selectedMarker: marker })
      },
      resetMarker: () => {
        set({ selectedMarker: null })
      },
    },
  })),
)
